import type { WrapperProps } from "@/modules/companies/client/components/Wrapper/types"
import type { PagesRouterPage, PagesRouterPageProps } from "@/types"
import type { GetServerSideProps } from "next"

import { Newsfeed } from "@/modules/companies/client/components/Newsfeed/Newsfeed"
import { Wrapper } from "@/modules/companies/client/components/Wrapper/Wrapper"
import { getServerSideNewsfeedProps } from "@/modules/companies/client/utils/getServerSideNewsfeedProps"

const CompanyNewsfeed: PagesRouterPage<WrapperProps> = props => (
  <Wrapper {...props}>
    <Newsfeed />
  </Wrapper>
)

const getServerSideProps: GetServerSideProps<PagesRouterPageProps<WrapperProps>> = async context =>
  getServerSideNewsfeedProps(context)

export { CompanyNewsfeed as default, getServerSideProps }
